// import { Alert as AlertMantine } from '@mantine/core'
import React, { useState } from 'react'
import { useQuery } from 'react-query'

// import { ReactComponent as InfoIcon } from '../../../../icones/infoAmarelo.svg'
import { DashboardsService } from '../../../../services/http/dashboards.service'
// import { formatDateToLabel } from '../../../../utils/genericFormatters'
import MenuRadio from '../../../Mantine/MenuRadio'
import LineSkeleton from '../../../Mantine/Skeleton/line'

import Grafico from './Grafico'
import * as S from './styles'

const options = [
  { value: '24h', label: 'Últimas 24h' },
  { value: '2d', label: 'Últimos 2 dias' },
  { value: '3d', label: 'Últimos 3 dias' },
  { value: '4d', label: 'Últimos 4 dias' },
  { value: '5d', label: 'Últimos 5 dias' },
  { value: '6d', label: 'Últimos 6 dias' },
  { value: '7d', label: 'Últimos 7 dias' }
]

export default function Consumo() {
  const [selectedButton, setSelectedButton] = useState('24h')
  // const [mostrarAlerta, setMostrarAlerta] = useState(false)
  const [loading, setLoading] = useState(false)
  // const [datasDisponiveis, setDatasDisponiveis] = useState({
  //   min: undefined,
  //   max: undefined
  // })

  const { getConsumoPortadoras } = DashboardsService

  const { data } = useQuery(
    [`carrier/history/consumption`, selectedButton],
    async () => {
      try {
        setLoading(true)
        return await getConsumoPortadoras(selectedButton)
      } catch (err) {
        console.error('Erro ao buscar consumo:', err)
        return [] // Evita erros ao mapear `data` caso falhe
      } finally {
        setLoading(false)
      }
    },
    {
      // onSuccess: (data) => {
      //   if (!data?.length) return

      //   const parsedDates = data.map((item) => parseISO(item.data))

      //   const today = new Date()
      //   const minDate = min(parsedDates)
      //   const maxDate = max(parsedDates)
      //   setDatasDisponiveis({
      //     min: minDate,
      //     max: maxDate
      //   })

      //   const isMaxDateBeforeToday = isBefore(maxDate, today)

      //   const days = parseInt(selectedButton, 10)
      //   const startDate = subDays(today, days)

      //   const isMinDateAfterStartDate = isAfter(minDate, startDate)

      //   if (isMinDateAfterStartDate || isMaxDateBeforeToday) {
      //     setMostrarAlerta(true)
      //   }
      // },
      keepPreviousData: true,
      refetchOnWindowFocus: false
    }
  )

  // const handleFecharAlerta = () => setMostrarAlerta(false)

  // const getMensagemAlerta = () => {
  //   if (!datasDisponiveis?.min) return ''

  //   const dataInicio = formatDateToLabel(datasDisponiveis.min)
  //   const dataFim = formatDateToLabel(datasDisponiveis.max)

  //   const intervalo = isSameDay(datasDisponiveis.min, datasDisponiveis.max)
  //     ? `do dia ${dataInicio}`
  //     : `de ${dataInicio} a ${dataFim}`

  //   return `Nem todos os dias do período selecionado possuem dados disponíveis. Estamos exibindo as informações ${intervalo}.`
  // }

  const handleFilter = (value) => {
    if (!value.type) return

    setSelectedButton(value.type)
    // setMostrarAlerta(false)
  }

  return (
    <S.HistoricoWrapper>
      <S.DashboardHeader className="dash-boardheader">
        <div>
          <S.Title>Histórico de consumo</S.Title>
          <S.SubTitle>{options.find(option => option.value === selectedButton)?.label}</S.SubTitle>
        </div>
        <MenuRadio options={options} onClick={handleFilter} scaleIcon={1} />
      </S.DashboardHeader>

      {loading && <LineSkeleton height={305} visible={loading} />}
      {!loading && (
        <>
          <Grafico data={data} />
          {/* {mostrarAlerta && (
            <S.AlertWrapper>
              <AlertMantine
                radius="sm"
                title="Atenção!"
                type="warning"
                color="yellow"
                withCloseButton
                onClose={handleFecharAlerta
                icon={<InfoIcon alt="info" />}
              >
                {getMensagemAlerta()}
              </AlertMantine>
            </S.AlertWrapper>
          )} */}
        </>
      )}
    </S.HistoricoWrapper>
  )
}
